let testHostnameOverride: string | undefined

export function __setBrowserHostnameForTests(hostname: string | undefined): void {
  testHostnameOverride = hostname
}

export function getBrowserHostname(): string | undefined {
  if (testHostnameOverride !== undefined) {
    return testHostnameOverride
  }

  if (typeof window === 'undefined') {
    return undefined
  }

  return window.location.hostname
}
